<template>
  <div>
    <!-- no credit score found -->
    <template v-if="noCreditScore">
      <CreditResultsNoResults
        :dealershipName="$store.state.business.info.name"
        class="pt-3 pt-sm-4 pb-2 pb-sm-3 px-0 px-sm-5"
      >
      </CreditResultsNoResults>
      <ApplyNow v-if="financeApplicationEnabled" class="mt-5"></ApplyNow>
    </template>
    <!-- credit score found -->
    <div v-else>
      <USCreditResults v-if="getThisIsAmerica" data-test="USCredit"></USCreditResults>
      <TUCreditResults v-else-if="isCreditPlus" data-test="creditPlusTU"></TUCreditResults>
      <div v-else-if="preQualificationEnabled">
        <ConsumerInventoryMatchingResults v-if="prequalificationConsumerInventoryMatchingEnabled" data-test="CIMCredit">
        </ConsumerInventoryMatchingResults>
        <PrequalCreditResults v-else data-test="prequalCredit"> </PrequalCreditResults>
      </div>
      <EquifaxAndRegionalCreditResults v-else data-test="equifaxAndRegionalCredit"></EquifaxAndRegionalCreditResults>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PrequalFinanceProviderCodes } from '@/utils/enums';
import CreditResultsNoResults from '@/components/CreditResultsNoResults.vue';
import ApplyNow from '@/components/credit/ApplyNow.vue';
import helperFunctions from '@/utils/helperFunctions';
import ConsumerInventoryMatchingResults from '@/components/credit-results/ConsumerInventoryMatchingResults.vue';
import EquifaxAndRegionalCreditResults from '@/components/credit-results/EquifaxAndRegionalCreditResults.vue';
import USCreditResults from '@/components/credit-results/USCreditResults.vue';
import TUCreditResults from '@/components/credit-results/TUCreditResults.vue';
import PrequalCreditResults from '@/components/credit-results/PrequalCreditResults.vue';

export default {
  name: 'CreditResults',
  beforeRouteLeave: helperFunctions.ignoreRoutes([
    'credit-carfax-trade-in',
    'credit-carfax-details-form',
    'other-monthly-expenses',
    'confirm-id',
    'select-auto-loan',
    'trade-in-balance',
  ]),
  components: {
    PrequalCreditResults,
    TUCreditResults,
    USCreditResults,
    EquifaxAndRegionalCreditResults,
    ApplyNow,
    CreditResultsNoResults,
    ConsumerInventoryMatchingResults,
  },
  data() {
    return {
      prequalLoading: true,
      prequalFinanceProviderCodes: PrequalFinanceProviderCodes,
    };
  },
  computed: {
    ...mapGetters('credit', [
      'creditScoreGrade',
      'regionalCreditScoreGrade',
      'preQualificationLoansExist',
      'preQualificationEnabled',
      'hasCreditPlusCreditResults',
    ]),
    ...mapGetters('usCredit', ['getUsCreditScore']),
    ...mapGetters('business', [
      'getThisIsAmerica',
      'getDefaultCreditDataSourceCA',
      'prequalificationConsumerInventoryMatchingEnabled',
      'financeApplicationEnabled',
    ]),
    shownGrade() {
      if (this.getThisIsAmerica) {
        return this.getUsCreditScore;
      }
      return this.creditScoreGrade ? this.creditScoreGrade : this.regionalCreditScoreGrade;
    },
    isCreditPlus() {
      return this.hasCreditPlusCreditResults;
    },
    noCreditScore() {
      return !this.shownGrade;
    },
  },
  async mounted() {
    // lead will be updated in prequal and CIM credit results pages
    if (!this.preQualificationEnabled) {
      try {
        await this.$store.dispatch('lead/updateLead');
      } catch (err) {
        this.$log('Error in update lead credit results page', err);
      }
    }
    this.$store.commit('SET_DHS_STATE', ['credit', 'half-complete']);
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
</style>
